import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Bot = createReactComponent("Bot", ["svg", defaultAttributes, [["rect", {
  x: "3",
  y: "11",
  width: "18",
  height: "10",
  rx: "2",
  key: "rk0hcj"
}], ["circle", {
  cx: "12",
  cy: "5",
  r: "2",
  key: "1i986l"
}], ["path", {
  d: "M12 7v4",
  key: "1fq99g"
}], ["line", {
  x1: "8",
  y1: "16",
  x2: "8",
  y2: "16",
  key: "uw7els"
}], ["line", {
  x1: "16",
  y1: "16",
  x2: "16",
  y2: "16",
  key: "6xq6mo"
}]]]);
export default Bot;